var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49992 10.6666V7.99998M7.49992 5.33331H7.50659M14.1666 7.99998C14.1666 11.6819 11.1818 14.6666 7.49992 14.6666C3.81802 14.6666 0.833252 11.6819 0.833252 7.99998C0.833252 4.31808 3.81802 1.33331 7.49992 1.33331C11.1818 1.33331 14.1666 4.31808 14.1666 7.99998Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoHover);
export default __webpack_public_path__ + "static/media/Info_hover.1e832b8c8ca723cc41dbb91330994b44.svg";
export { ForwardRef as ReactComponent };